module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "err"
  }, [(_vm.err) ? _c('p', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.err) + " "), _c('span', {
    staticClass: "reload-link",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Reload Page")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0b6c5f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/error.vue
// module id = 419
// module chunks = 2